const files = import.meta.globEager('./**/*.{js,ts}')

const modules = {}

Object.entries(files).forEach((apis) => {
  const childModule = apis[1].default
  for (const key in childModule) {
    if (modules[key]) {
      throw new Error(`Api的名称[${key}]不得重复（虽然你可以写在不同的模块中，但api的key必须唯一）`)
    }
    modules[key] = childModule[key]
  }
})

export default modules
